import { Button as CtvButton } from '@accedo/ctv-button';
import { FunctionalComponent, Ref } from 'preact';
import { forwardRef } from 'preact/compat';

import { stylesheet } from 'astroturf';
import { BaseNav, Nav, NavProps, NavState } from '@accedo/spatial-nav';

const TEXT = {
  TITLE: 'Are you sure you want to Sign Out?',
  BODY: 'Just hit `Sign Out` to sign out of 10.',
  SIGN_OUT: 'Sign out',
  STAY_SIGNED_IN: 'Stay signed in',
};

const styles = stylesheet`
  @import '##/styles/import.scss';

  .modal-outer-tag {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 99;
    top: 0;
  }

  .modal-content-box {
    width: pxToVw(366);
    height: pxToVh(300);
    margin: 20vh auto 0;
    text-align: center;
    background: transparent
      linear-gradient(180deg, rgb(24, 31, 38) 0%, rgb(6, 7, 9) 100%) 0% 0%
      no-repeat padding-box;
  }

  .modal-header {
    font-size: 2.75rem;
    padding: 5vh 0 1.5vh;
    font-family: barlow;
    line-height: pxToVh(34);
  }

  .modal-subtext {
    font-size: 1.6rem;
    padding: 1vh;
    font-family: barlow;
  }

  :global(.button).sign-out-button {
    display: block;
    font-family: barlowsemicondensed;
    font-size: pxToVh(18);
    width: pxToVw(244);
    padding: pxToVw(10) pxToVw(27) pxToVw(14);
    margin: pxToVh(15) auto 0;
    border-radius: pxToVw(80);
    background: rgb(0, 0, 6) 0% 0% no-repeat padding-box;
    border: 1px solid $pure-white;

    &:global(.current-focus) {
      background: linear-gradient(
          90deg,
          $ten-play-blue 0%,
          rgb(14, 163, 253) 100%
        )
        0% 0% no-repeat padding-box;
      border-color: transparent;
    }
  }
`;

interface SignOutModalProps {
  navRef: Ref<BaseNav<NavProps, NavState>>;
  defaultFocusId: string;
  actions: {
    onExitModal: () => void;
    onSignOut: () => void;
  };
}

const SignOutModalContent: FunctionalComponent<SignOutModalProps> = ({
  navRef,
  defaultFocusId,
  actions,
}) => {
  const signOutButtonId = 'sign-out-modal-leave-button';
  const staySignedOutButtonId = 'sign-out-modal-stay-button';
  return (
    <div className={styles.modalOuterTag}>
      <Nav.Vertical id={defaultFocusId} ref={navRef}>
        <div className={styles.modalContentBox}>
          <div className={styles.modalHeader}>{TEXT.TITLE}</div>
          <div className={styles.modalSubtext}>{TEXT.BODY}</div>
          <CtvButton
            className={styles.signOutButton}
            navId={signOutButtonId}
            onClick={actions.onSignOut}
          >
            {TEXT.SIGN_OUT}
          </CtvButton>
          <CtvButton
            className={styles.signOutButton}
            navId={staySignedOutButtonId}
            onClick={actions.onExitModal}
          >
            {TEXT.STAY_SIGNED_IN}
          </CtvButton>
        </div>
      </Nav.Vertical>
    </div>
  );
};

export const SignOutModalRef = forwardRef<BaseNav<NavProps, NavState>, SignOutModalProps>(
  (props: SignOutModalProps, ref: Ref<BaseNav<NavProps, NavState>>) => {
    const modalProps: SignOutModalProps = {
      ...props,
      navRef: ref,
    };
    return <SignOutModalContent {...modalProps} />;
  },
);
